import React from "react";
import PublicArticleList from "./PublicArticleList";

export default function Essays() {
  return (
    <PublicArticleList
      kind="essay"
      overline="Essays"
      title="On AI, markets, and everything adjacent."
      lede="Pieces that wouldn't sit quietly in a novel. Argued honestly, sourced properly, and written in the belief that the truth is rarely glamorous and almost always useful."
      emptyTitle="No essays have been published yet."
      emptyNote="They will live here when they are ready."
      dataTestid="public-essays"
      baseRoute="/essays"
      heroImage={{
        src: "/images/briefcase-fairy-transparent.png",
        alt: "A fairy in a pinstripe suit and red heels carrying a battered leather briefcase, iridescent wings behind her.",
        caption: "The essayist, mid-commute.",
      }}
    />
  );
}
